import React from "react";
import { motion } from "framer-motion";
import { Handshake, TrendingUp, Users, Settings, Target, UserPlus, ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { FadeUp } from "../components/primitives";
import { Button } from "../components/primitives";
import { useLang } from "../i18n";

const icons = [Handshake, TrendingUp, Users, Settings, Target, UserPlus];

const Solutions = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden">
      <PageHero over={t.solutionsPage.heroOver} title={t.solutionsPage.heroTitle} sub={t.solutionsPage.heroSub} />

      <section className="py-20 md:py-28 bg-white">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10">
          {t.solutions.map((s, i) => {
            const Icon = icons[i];
            const reverse = i % 2 === 1;
            return (
              <FadeUp key={i}>
                <div className={`grid lg:grid-cols-2 gap-10 lg:gap-20 items-center py-14 border-t border-wanm-dark/10 ${reverse ? "lg:[direction:rtl]" : ""}`}>
                  <div className="[direction:ltr]">
                    <span className="text-7xl md:text-8xl font-black text-wanm-dark/10">0{i + 1}</span>
                    <h2 className="mt-2 text-3xl md:text-5xl font-black tracking-tight text-wanm-dark">{s.t}</h2>
                    <p className="mt-5 text-lg md:text-xl text-wanm-dark/60 leading-relaxed max-w-lg">{s.d}</p>
                    <div className="mt-8"><Button variant="outline" to="/contact" testId={`sol-cta-${i}`}>{t.cta.talk}</Button></div>
                  </div>
                  <div className="[direction:ltr]">
                    <motion.div whileHover={{ scale: 1.02 }}
                      className="relative rounded-3xl aspect-[4/3] wanm-gradient-bg overflow-hidden grain flex items-center justify-center"
                      data-testid={`sol-visual-${i}`}>
                      <img src="/logos/isotype.png" alt="" className="absolute w-1/2 opacity-20" />
                      <Icon className="text-white relative z-10" size={80} strokeWidth={1.5} />
                    </motion.div>
                  </div>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </section>

      <section className="py-24 wanm-gradient-bg relative overflow-hidden grain">
        <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-10 text-center">
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter text-white">{t.home.finalTitle}</h2>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="dark" to="/contact">{t.cta.talk}</Button>
            <Button variant="outlineLight" to="/for-publishers">{t.cta.publisher}</Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
